import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import { Helmet } from "react-helmet-async";
const values = [
  { icon: '🎯', title: 'Our Mission', desc: 'To empower businesses with innovative digital strategies that drive measurable growth, increase brand visibility, and generate consistent revenue in the online space.' },
  { icon: '🔭', title: 'Our Vision', desc: 'To be the most trusted digital marketing partner for businesses across India and beyond, delivering transformative results through technology and creativity.' },
  { icon: '💡', title: 'Our Approach', desc: 'We combine data-driven insights with creative excellence to craft strategies that are uniquely tailored to each client\'s goals, audience, and market position.' },
];

const milestones = [
  { year: '2018', event: 'DMS Technologies Founded in Virar, Mumbai' },
  { year: '2019', event: 'First 50 clients onboarded across Mumbai region' },
  { year: '2020', event: 'Expanded services to include full website development' },
  { year: '2021', event: 'Crossed 100+ website projects milestone' },
  { year: '2022', event: 'Launched advanced Meta & Google Ads division' },
  { year: '2023', event: 'Reached 300+ website projects and 93+ social accounts' },
  { year: '2024', event: 'Expanded to serve clients across India & internationally' },
  { year: '2026', event: 'Trusted by 500+ businesses — Growing stronger every day' },
];

export default function About() {

  useEffect(() => {

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll(".animate-on-scroll").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();

  }, []);

  return (
    
    
    <div className="about-page">
      

      {/* HERO */}
     <section className="page-hero">
  <div className="container page-hero-content hero-animate">
    <span className="section-tag">About DMS Technologies</span>
    <h1>Your Digital <span>Growth Partner</span></h1>
    <p>
      A result-driven digital marketing and website development company
      helping businesses grow and succeed in the digital world.
    </p>
  </div>
</section>

      {/* ABOUT STORY */}
      <section className="about-story">
        <div className="container">

          <div className="story-grid">

            <div className="story-text animate-on-scroll">

              <span className="section-tag">Who We Are</span>

              <h2 className="section-title">
                About <span>DMS Technologies</span>
              </h2>

              <p>
                DMS Technologies is a result-driven digital marketing and
                website development company dedicated to helping businesses
                grow and succeed in the digital world.
              </p>

              <p>
                Our team combines creativity, advanced technology, and
                data-driven insights to deliver customized solutions tailored
                to your business goals.
              </p>

              <p>
                At DMS Technologies, we focus on measurable results,
                transparent communication, and long-term growth.
              </p>

              <Link to="/contact" className="btn-primary" style={{marginTop:'24px',display:'inline-block'}}>
                Work With Us
              </Link>

            </div>

            <div className="story-stats animate-on-scroll">

              <div className="ss-card">
                <div className="ss-big">300+</div>
                <div className="ss-label">Website Projects</div>
              </div>

              <div className="ss-card">
                <div className="ss-big">93+</div>
                <div className="ss-label">Social Media Accounts Managed</div>
              </div>

              <div className="ss-card">
                <div className="ss-big">500+</div>
                <div className="ss-label">Happy Clients</div>
              </div>

              <div className="ss-card">
                <div className="ss-big">6+</div>
                <div className="ss-label">Years of Excellence</div>
              </div>

            </div>

          </div>

        </div>
      </section>

      {/* MISSION VISION */}
      <section className="mv-section">

        <div className="container">

          <div className="section-header animate-on-scroll">
            <span className="section-tag">Our Foundation</span>
            <h2 className="section-title">
              Mission, Vision & <span>Approach</span>
            </h2>
          </div>

          <div className="mv-grid">

            {values.map((v, i) => (

              <div className="mv-card animate-on-scroll" key={i}>
                <div className="mv-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>

            ))}

          </div>

        </div>

      </section>

      {/* TIMELINE */}
      <section className="timeline-section">

        <div className="container">

          <div className="section-header animate-on-scroll">
            <span className="section-tag">Our Journey</span>
            <h2 className="section-title">
              DMS <span>Milestones</span>
            </h2>
          </div>

          <div className="timeline">

            {milestones.map((m, i) => (

              <div className={`timeline-item animate-on-scroll ${i % 2 === 0 ? "left" : "right"}`} key={i}>

                <div className="tl-dot"></div>

                <div className="tl-card">
                  <span className="tl-year">{m.year}</span>
                  <p>{m.event}</p>
                </div>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* TEAM CTA */}
      <section className="team-cta-section">

        <div className="container">

          <div className="team-cta-card animate-on-scroll">

            <div className="tc-text">
              <h2>
                Join <span>dms technologies</span>
              </h2>
              <p>Join our team and shape the future of digital innovation</p>
            </div>

           <a  href="mailto:info@dmstechnologies.com"
  className="btn-primary"
>
  Apply Now – Send Your CV →
</a>

          </div>

        </div>

      </section>

    </div>
  );
}